import { useCreditAccountTransactionByFiltersQuery } from "@/gqlhooks/profile/useCreditAccountTransactionByFiltersQuery";
import { CreditTypeEnum } from "@/__generated__/graphql";
import { CreditAccountTransactionScreen } from "./CreditAccountTransaction.screen";
import { useProfileState } from "@/store/profile";
import { startOfYear, endOfMonth } from "date-fns";
import { useRoute } from "@/components/shared/router";

export const CreditAccountTransactionContainer = () => {
  const { pull } = useRoute();
  const creditAccountType = useProfileState(
    (state) => state.data.creditAccountType,
  );
  const departmentLinkedNameByType = {
    massage: "MASSAGE",
    beauty: "HOME_BEAUTY",
    pet: "PET_CARE",
  } as const;

  const today = new Date();
  const generalType = creditAccountType === "general";

  const startDate = startOfYear(today);
  const endDate = endOfMonth(today);

  const authorizedAtFrom = startDate.toISOString();
  const authorizedAtTo = endDate.toISOString();

  const { list } = useCreditAccountTransactionByFiltersQuery(
    {
      offset: 0,
      authorizedAtFrom,
      authorizedAtTo,
    },
    generalType ? CreditTypeEnum.General : CreditTypeEnum.Department,
    generalType || creditAccountType === "overview"
      ? undefined
      : departmentLinkedNameByType[creditAccountType],
  );

  return <CreditAccountTransactionScreen transactions={list} onBack={pull} />;
};
